import {
  constructList,
  getText,
  sortAndSliceList,
  appendGOATandCountryCodeToTitle,
  stripSpecialCharacterFromString,
} from 'shared/utils/pageMetadataUtils';
import { startCase } from 'shared/utils/startCase';
import { t } from 'localization/utils/t';

const TP = 'shared.utils.getSilhouetteMetadata';

export const getSilhouetteMetadata = ({
  pageTitle,
  pageDescription,
  constructorResponse,
  locale,
  query,
}) => {
  const { groups = [], results = [] } = constructorResponse?.response || {};
  const silhouette: string = startCase(query?.silhouette);
  const topLevelCategory: string =
    groups?.[0]?.group_id === 'sneakers'
      ? t(`${TP}.shoes`, 'shoes')
      : stripSpecialCharacterFromString(groups?.[0]?.group_id);
  const topLevelCategoryWithStartCase: string = startCase(topLevelCategory);
  const topThreePTs = constructList({ list: sortAndSliceList(results), key: 'value' });
  const topThreePTsCustom = topThreePTs?.constructedList?.map((string) =>
    string.trim() === '&' ? ', ' : string,
  );

  const includingTheTopThreePTsAndMore =
    topThreePTsCustom?.length > 0
      ? t(`${TP}.includingTheTopThreePTsAndMore`, 'including the {pts} and more', {
          pts: getText('', topThreePTsCustom),
        })
      : '';

  const title = t(
    `${TP}.title`,
    'Buy {silhouette} {topLevelCategoryWithStartCase}: New Releases & Iconic Styles',
    {
      silhouette,
      topLevelCategoryWithStartCase,
    },
  );
  const description = t(
    `${TP}.description`,
    'Shop {silhouette} {topLevelCategory} on GOAT. Featuring new, upcoming and iconic styles {includingTheTopThreePTsAndMore}. Buyer protection guaranteed on all purchases',
    {
      silhouette,
      topLevelCategory,
      includingTheTopThreePTsAndMore,
    },
  );

  return {
    pageTitle: pageTitle || appendGOATandCountryCodeToTitle(title, locale),
    pageDescription: pageDescription || description,
  };
};
